module.exports = ".ui-datatable-data > tr > td {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 150px;\r\n}\r\n"